module.exports = __webpack_public_path__ + "img/frame (25).c710c7ac.jpg";